// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"3aeb3721","787":"8a7d5dfe","931":"436924c8"}[chunkId] + ".chunk.js";
};